// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2mZlv","requiredAsterisk":"Info_requiredAsterisk__1Fy5R"};